




















import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SearchIcon from '@/components/icons/SearchV2.vue';

@Component({
  components: {
    Typography,
    SearchIcon
  }
})
export default class SearchBarEmptyState extends Vue {
  @Prop() text!: string;

  get tPrefix() {
    return 'common.components.selectDropdownField.searchBar.emptyState';
  }
}
